<template>
  <div class="idCard">
    <div v-if="status == 2" class="cardOk">
      {{ $t("works.你的认证信息已审核通过") }}
    </div>
    <div v-if="status == 1" class="cardOk">
      {{ $t("works.认证信息审核中") }}
    </div>
    <div v-if="status == 0 || status == 3">
      <div class="title">
        {{ $t("works.注：以下信息仅用于竞赛实名认证，我们将严格保密") }}
      </div>
      <div class="nameBox clearfix">
        <div class="label"><span>*</span>{{ $t("works.真实姓名") }}</div>
        <div class="inputBox">
          <el-input
            v-model="personalDetail.realName"
            :placeholder="$t('works.请输入真实姓名')"
          ></el-input>
        </div>
      </div>
      <div class="nameBox clearfix">
        <div class="label"><span>*</span>{{ $t("works.身份证号码") }}</div>
        <div class="inputBox">
          <el-input
            v-model="personalDetail.idcardCode"
            :placeholder="$t('works.请输入身份证号码')"
          ></el-input>
        </div>
      </div>
      <div class="nameBox clearfix">
        <div class="label"><span>*</span>{{ $t("works.认证信息") }}</div>
        <div class="inputBox clearfix">
          <div class="imgBox" @click="changeInput(1)">
            <div
              class="img"
              v-if="personalDetail.idcardPersonImage || idcardPersonImage"
              :style="
                personalDetail.idcardPersonImage ||
                idcardPersonImage
                  | bgImageUrl('', '/static/manageCenter/front.png')
              "
            ></div>
            <div class="textTitle" v-else>
              <div class="title1">{{ $t("works.上传手持身份证照") }}</div>
              <div class="title1">{{ $t("works.（个人信息面）") }}</div>
            </div>
          </div>
          <div class="imgBox" @click="changeInput(2)">
            <div
              class="img"
              v-if="personalDetail.idcardImageFront"
              :style="
                personalDetail.idcardImageFront
                  | bgImageUrl('', '/static/manageCenter/front.png')
              "
            ></div>
            <div class="textTitle" v-else>
              <div class="title1">{{ $t("works.上传身份证正面照片") }}</div>
              <div class="title1">{{ $t("works.（个人信息面）") }}</div>
            </div>
          </div>
          <div class="imgBox" @click="changeInput(3)">
            <div
              class="img"
              v-if="personalDetail.idcardImageBack"
              :style="
                personalDetail.idcardImageBack
                  | bgImageUrl('', '/static/manageCenter/front.png')
              "
            ></div>
            <div class="textTitle" v-else>
              <div class="title1">{{ $t("works.上传身份证反面照片") }}</div>
              <div class="title1">{{ $t("works.（国徽面）") }}</div>
            </div>
          </div>
        </div>
      </div>
      <input
        style="display: none"
        type="file"
        class="upInputStep0"
        accept="image/*"
        @change="upImg"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      idcardPersonImage: null,
      idcardImageFront: null,
      idcardImageBack: null,
    };
  },
  props: ["personalDetail", "status"],
  created() {},
  mounted() {},
  computed: {
    language() {
      return this.$language();
    },
  },
  watch: {},
  methods: {
    changeInput(index) {
      this.$store.dispatch("setImgIndex", index);
      document.querySelector(".upInputStep0").click();
    },
    upImg(e) {
      let param = new FormData();
      let $this = this;
      param.append("files", e.target.files[0]);
      let size = e.target.files[0].size / 1024 / 1024 <= 10;
      if (!size) {
        this.$message(
          `${this.$t("global.请上传")}10M${this.$t("global.以内的图片")}`
        );
        return false;
      }
      let file_ = document.querySelector(".upInputStep0");
      this.$jsonUtils.checkImageSize(
        file_,
        e.target.files[0],
        350,
        350,
        function (data) {
          if (data.state) {
            $this.$http
              .post("/api/common/upload/image/mark", param, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((response) => {
                $this.$message({
                  message: response.message,
                  type: "success",
                });
                switch ($this.$store.state.imgIndex) {
                  case 1:
                    $this.idcardPersonImage = response.data.markKey;
                    $this.personalDetail.idcardPersonImage = response.data.key;
                    break;
                  case 2:
                    $this.idcardImageFront = response.data.markKey;
                    $this.personalDetail.idcardImageFront = response.data.key;
                    break;
                  case 3:
                    $this.idcardImageBack = response.data.markKey;
                    $this.personalDetail.idcardImageBack = response.data.key;
                    break;
                }
              });
          } else {
            $this.$message.info(
              $this.$t("global.文件大小不能小于") + "350 * 350"
            );
          }
        }
      );
    },
    submit() {
      if (this.status == 2 || this.status == 1) {
        this.$emit("callback", true);
        //点击下一步回到上面
        this.$nextTick(() => {
          document.getElementById("nav").scrollIntoView(true);
        });
        return;
      }
      if (this.personalDetail.realName == "") {
        this.$message.error(this.$t("works.请输入真实姓名"));
        return;
      }
      if (this.personalDetail.idcardCode == "") {
        this.$message.error(this.$t("works.请输入身份证号码"));
        return;
      }
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(this.personalDetail.idcardCode) === false) {
        this.$message.error(this.$t("global.身份证格式不正确"));
        return;
      }
      if (!this.personalDetail.idcardPersonImage) {
        this.$message.error(this.$t("works.请上传手持证件照正面"));
        return;
      }
      if (!this.personalDetail.idcardImageFront) {
        this.$message.error(this.$t("works.请上传证件照正面"));
        return;
      }
      if (!this.personalDetail.idcardImageBack) {
        this.$message.error(this.$t("works.请上传证件照反面"));
        return;
      }
      this.$http
        .post("/api/u/certification/personal/save", {
          idcardCode: this.personalDetail.idcardCode,
          realName: this.personalDetail.realName,
          idcardImageFront:
            this.idcardImageFront || this.personalDetail.idcardImageFront,
          idcardImageBack:
            this.idcardImageBack || this.personalDetail.idcardImageFront,
          idcardPersonImage:
            this.idcardPersonImage || this.personalDetail.idcardImageFront,
        })
        .then((response) => {
          if (response.code === "OK") {
            this.$emit("callback", true);
            //点击下一步回到上面
            this.$nextTick(() => {
              document.getElementById("nav").scrollIntoView(true);
            });
          }
        });
    },
  },
};
</script>
<style>
.nameBox .el-input__inner {
  border: 1px solid #e0e0e0;
  border-radius: 0;
}
</style>
<style lang="stylus" scoped>
.idCard {
  padding: 0 50px 50px;

  .cardOk {
    padding-top: 60px;
    height: 25px;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
    text-align: center;
  }

  .title {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }

  .nameBox {
    margin-top: 30px;

    .label {
      float: left;
      width: 142px;
      text-align: right;
      font-size: 16px;
      font-weight: 500;
      color: #333;

      span {
        color: #FE5630;
        margin-right: 5px;
      }
    }

    .inputBox {
      float: left;
      margin-left: 18px;

      .el-input {
        width: 285px;
      }

      .imgBox {
        width: 285px;
        height: 163px;
        float: left;
        margin-right: 20px;
        border: 1px solid #E0E0E0;
        box-sizing: border-box;
        cursor: pointer;

        &:nth-last-child(1) {
          margin-right: 0;
        }

        .img {
          width: 285px;
          height: 163px;
          background-size: 100% 100%;
        }

        .textTitle {
          width: 285px;
          height: 163px;
          padding-top: 60px;
          box-sizing: border-box;

          .title1 {
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/match/contestEnterStep/step0.vue